// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3mFhW","content":"style_content__2nV42","title":"style_title__2WwNy","subtitle":"style_subtitle__2lvLt","wrapper":"style_wrapper__15hLO"};